/**
 * This is only for legacy support, so we convert IDs when deserializing
 * @type {import("../../utility/serializers").SerializerType}
 */
export const binaryId = {
    serialize: raw => '' + raw || null,
    deserialize: id => {
        if (typeof id === 'string') {
            id = parseInt(id)
        }
        return (id === 4) ? 3 : id
    },
}
